/** Bottom sheet snap points for authorized users */
export const SHEET_SNAP_AUTHORIZED = [300];

/** Bottom sheet snap points for guest users */
export const SHEET_SNAP_GUEST = [150];
